module.exports = __webpack_public_path__ + "static/assets/526f79c867932ad4c0a183f88005b77f.png";